import { observer } from 'mobx-react-lite';
import {
  Button,
  CenterGroup,
  LeftGroup,
  RightGroup,
  ToggleButtons,
  Toolbar as ToolbarComponent,
} from '../../../components';
import Promotions from '../store/Promotions';

export default observer(function Toolbar({
  promotions,
}: {
  promotions: Promotions;
}) {
  return (
    <ToolbarComponent sx={{ mb: 3 }}>
      <LeftGroup />

      <CenterGroup>
        <ToggleButtons
          onChange={promotions.setStateFilter}
          options={[
            { label: 'All', value: 'all' },
            { label: 'Current', value: 'current' },
            { label: 'Future', value: 'future' },
            { label: 'Expired', value: 'expired' },
          ]}
          value={promotions.stateFilter}
        />
      </CenterGroup>

      <RightGroup>
        <Button
          icon="plus"
          onClick={promotions.addPromotion}
          size="small"
          type="primary"
        >
          Create Promotion
        </Button>
      </RightGroup>
    </ToolbarComponent>
  );
});
